import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../web/components-v2/Theme/theme';
import { shadowLg } from '../../../../web/styles/shadows';

export const ticketSummaryPopoverStyles = StyleSheet.create({
	trigger: {
		display: 'inline-flex',
		alignItems: 'center',
		gap: 5,
		flex: 'none',
		height: 24,
		padding: '0 9px',
		borderRadius: 12,
		fontSize: THEME.typography.fontSizes.xs,
		fontWeight: THEME.typography.fontWeights.semibold,
		color: THEME.colors.primary.main,
		backgroundColor: THEME.colors.primary.light,
		border: 'none',
		cursor: 'pointer',
		':hover': {
			backgroundColor: THEME.colors.primary.main,
			color: THEME.colors.primary.contrastText,
		},
	},
	popover: {
		display: 'flex',
		flexDirection: 'column',
		width: 390,
		maxWidth: 'calc(100vw - 24px)',
		// Radix reports the room under the trigger; without capping to it the panel runs off a short
		// window instead of scrolling its body.
		maxHeight: 'min(460px, var(--radix-popover-content-available-height, 460px))',
		padding: 0,
		overflow: 'hidden',
		// The popover portals to the body, so the desk's Sora base (inboxStyles.desk) doesn't reach it.
		fontFamily: THEME.typography.fontFamilies.sora,
		borderColor: THEME.colors.border.light,
		boxShadow: shadowLg,
	},
	header: {
		flex: 'none',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		gap: THEME.spacing.md,
		padding: `${THEME.spacing.md}px ${THEME.spacing.lg}px`,
		borderBottom: `1px solid ${THEME.colors.border.light}`,
	},
	title: {
		display: 'inline-flex',
		alignItems: 'center',
		gap: 7,
		fontSize: 15,
		fontWeight: THEME.typography.fontWeights.semibold,
		color: THEME.colors.text.main,
	},
	titleIcon: {
		flex: 'none',
		color: THEME.colors.primary.main,
	},
	generatedAt: {
		flex: 'none',
		fontSize: THEME.typography.fontSizes.xxs,
		color: THEME.colors.text.light,
	},
	// The only scroll region; the header stays put.
	body: {
		flexGrow: 1,
		minHeight: 0,
		overflowY: 'auto',
		overflowX: 'hidden',
		padding: `${THEME.spacing.md}px ${THEME.spacing.lg}px`,
	},
	section: {
		':not(:last-child)': {
			marginBottom: THEME.spacing.md,
		},
	},
	sectionLabel: {
		marginBottom: 3,
		fontSize: 10,
		fontWeight: THEME.typography.fontWeights.bold,
		letterSpacing: '0.07em',
		textTransform: 'uppercase',
		color: THEME.colors.text.light,
	},
	sectionValue: {
		fontSize: 13,
		lineHeight: 1.55,
		color: THEME.colors.text.main,
		// AI-written prose over a customer's own words: it can carry a long unbroken token.
		overflowWrap: 'anywhere',
	},
	state: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		minHeight: 60,
		textAlign: 'center',
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.light,
	},
});
